import { render, staticRenderFns } from "./PreReg.vue?vue&type=template&id=a2c83442&scoped=true&"
import script from "./PreReg.vue?vue&type=script&lang=js&"
export * from "./PreReg.vue?vue&type=script&lang=js&"
import style0 from "./PreReg.vue?vue&type=style&index=0&id=a2c83442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c83442",
  null
  
)

export default component.exports